import { AssetResponse } from '@research-api/utils/api/assets';
import { GlobalMarketData } from '@research-api/utils/api/research/GlobalMarketData';
import PostType from '@research-api/utils/api/typings/PostType';

import { withExceptionCatcher } from '@/components/hoc/withExceptionCatcher';
import PricePageLayout from '@/components/pages/price/layout/PricePageLayout';
import { IComponent } from '@/types/_app';
import { ArticleType } from '@/types/ArticleType';
import { Category } from '@/utils/functions/wordpress/fetchCategories';

export interface PricePageControllerProps {
    asset: AssetResponse;
    recentResearch: PostType;
    globalMarketHistory: GlobalMarketData[];
    categories: Category[];
    readMoreArticles: ArticleType[];
}

export const PricePageController: IComponent<any> = ({
    asset,
    recentResearch,
    globalMarketHistory,
    categories,
    readMoreArticles,
}: PricePageControllerProps) => {
    if (!asset) {
        return null;
    }

    return (
        <PricePageLayout
            asset={asset}
            recentResearch={recentResearch}
            globalMarketHistory={globalMarketHistory}
            categories={categories}
            readMoreArticles={readMoreArticles}
        />
    );
};

export default withExceptionCatcher(PricePageController);
